<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="900"
    @ok="handleOk"
    @cancel="handleCancel"
    okText="确认"
    cancelText="取消"
  >
    <a-card
      style="width:100%"
      :tabList="tabList"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <a-input-search
        v-model="inputQuery"
        placeholder="请输入搜索内容"
        style="width: 200px; margin-bottom: 20px;"
        @search="onSearch"
        enterButton
      />
      <a-table
        ref="table"
        size="default"
        :filterMultiple="false"
        :rowKey="item => item.id"
        :columns="columns"
        :dataSource="goodsList"
        :rowSelection="rowSelectionGoods"
        :scroll="{ y: 300 }"
        :pagination="goodsPagination"
        @change="handleTableChangeGoods"
        :loading="loading"
      >
        <span slot="image" slot-scope="val">
          <img :src="cdnImg(val)" class="thumbnail" />
        </span>
      </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
export default {
  name: 'SuitListModle',
  components: {
    STable
  },
  props: {
    matType: {
      type: String,
      default: 'radio'
    }
  },
  data() {
    return {
      visible: false,
      title: '选择套餐',
      inputQuery: '',
      noTitleKey: 'tab1',
      columns: [
        {
          title: '套餐名称',
          dataIndex: 'name'
        }
      ],
      goodsPagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      },
      loading: true,
      goodsList: [],
      activityList: [],
      pageParam: {
        page: 1,
        size: 10
      },
      productId: '',
      selectedRows: [],
      selectedGoodsRows: [],
      selectedActivityRows: [],
      radioSelectRows: [],
      selectKeys: []
    }
  },
  computed: {
    rowSelectionGoods() {
      return {
        type: this.matType,
        onChange: this.onGoodsChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name
          }
        })
      }
    },
    rowSelectionActivity() {
      return {
        type: this.matType,
        onChange: this.onActivityChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name
          }
        })
      }
    }
  },
  methods: {
    handleTableChangeGoods(pagination) {
      this.goodsPagination.current = pagination.current
      this.goodsPagination.pageSize = pagination.pageSize
      this.pageParam.page = pagination.current
      this.pageParam.size = pagination.pageSize
      this.getGoodsList()
    },

    // 商品选中
    onGoodsChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedGoodsRows = this.selectedGoodsRows.concat(selectedRows.concat(this.selectedActivityRows))
      this.radioSelectRows = selectedRows
    },
    // 活动选中
    onActivityChangeVal(selectedRowKeys, selectedRows) {
      this.selectKeys = selectedRowKeys
      if (this.matType === 'radio') {
        this.selectedRows = []
      }
      this.selectedActivityRows = this.selectedActivityRows.concat(selectedRows.concat(this.selectedGoodsRows))
      this.radioSelectRows = selectedRows
      // this.$forceUpdate()
    },
    // 显示/隐藏
    show() {
      this.visible = true
      this.getGoodsList()
    },
    // 提交
    handleOk() {
      this.visible = false
      this.selectedRows =
        this.matType === 'radio'
          ? this.radioSelectRows
          : this.deteleObject(this.selectedActivityRows.concat(this.selectedGoodsRows))
      this.$emit('selectSuitData', this.selectedRows)
      // 初始化
      this.inputQuery = ''
      this.pageParam.size = 10
      this.pageParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
    },
    // 关闭
    handleCancel() {
      this.visible = false
      // 初始化
      this.productId = ''
      this.selectedRows = []
      this.inputQuery = ''
      this.pageParam.size = 10
      this.pageParam.page = 1
      this.noTitleKey = 'tab1'
      this.goodsPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.activityPagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }
      this.selectKeys = []
      this.selectedRows = []
      this.selectedActivityRows = []
      this.selectedGoodsRows = []
    },
    // 商品与活动tab之间切换
    onTabChange(key, type) {
      if (key === 'tab2') {
        this.pageParam.size = this.activityPagination.pageSize
        this.activityPagination.current = 1
        this.inputQuery = ''
        this.pageParam.page = 1
        this.getActivityList()
      } else {
        this.pageParam.size = this.goodsPagination.pageSize
        this.goodsPagination.current = 1
        this.inputQuery = ''
        this.pageParam.page = 1
        this.getGoodsList()
      }
      this[type] = key
    },
    async getGoodsList() {
      this.loading = true
      const params = {
        name: this.inputQuery,
        current: this.pageParam.page,
        size: this.pageParam.size
      }
      const res = await this.$http.get('/s/marketing/mktProduct/getSuit', { params })
      this.goodsList = res.records
      this.goodsPagination.pageSize = res.size
      this.goodsPagination.total = res.total
      this.loading = false
      this.$forceUpdate()
    },

    onSearch() {
      this.pageParam.page = 1
      this.pageParam.size = 10
      this.getGoodsList()
    },
    // 去除数组中重复的对象
    deteleObject(obj) {
      const uniques = []
      const stringify = {}
      for (let i = 0; i < obj.length; i++) {
        const keys = Object.keys(obj[i])
        keys.sort(function(a, b) {
          return Number(a) - Number(b)
        })
        let str = ''
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j])
          str += JSON.stringify(obj[i][keys[j]])
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i])
          stringify[str] = true
        }
      }
      return uniques
    }
  }
}
</script>

<style lang="stylus" scoped>
.thumbnail {
  width: 50px;
  height: 50px;
}
</style>
